<template>
  <div class="com-article">
    <component 
      v-for="line, index in article.content"
      :key="index" 
      :is="line.cpt"
      :data-info="line.data"
      :articleInfo="article"
    />
  </div>
</template>

<script>
import { Article } from './main'
export default {
  props: {
    linkInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      article: {}
    }
  },
  created () {
    this.article = new Article('share', this.linkInfo)
  }
}
</script>

<style lang="less">
.com-article {
  line-height: 1.6;
  font-size: 16px;
  & > :first-child {
    margin-top: 8px;
  }
}
</style>